import { render, staticRenderFns } from "./section-error.vue?vue&type=template&id=c8a6b2b6"
import script from "./section-error.vue?vue&type=script&lang=js"
export * from "./section-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports